import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { PusherConnectionState } from '../../pusher/pusher-constants';

const initialState = {
  connectionState: PusherConnectionState.Disconnected,
};

const chatConnectionSlice = createSlice({
  name: 'chatConnection',
  initialState,
  reducers: {
    updateConnectionState: (state, action: PayloadAction<{ connectionState: PusherConnectionState }>) => {
      const { connectionState } = action.payload;
      state.connectionState = connectionState;
    },
  },
});

export const { updateConnectionState } = chatConnectionSlice.actions;

export default chatConnectionSlice.reducer;
